// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uq31t","fullView":"styles_fullView__34TTa"};